export const JSQ_PHONE = "(415) 841-2722";
export const JSQ_TEXT = "(415) 212-5999";
export const JSQ_SUPPORT_EMAIL = "investor-support@junipersquare.com";
export const JSQ_STAFF_SUPPORT_EMAIL = "support@junipersquare.com";
export const JSQ_GP_LITE_SUPPORT_EMAIL = "reporting-support@junipersquare.com";
export const JSQ_EMAIL_DOMAIN = "junipersquare.com";

// ERROR MESSAGES FOR UNEXPECTED GQL MUTATION ERRORS
export const SEND_CODE_UNEXPECTED_ERROR_MESSAGE =
  "Failed to send two-factor authentication code";
export const VERIFY_CODE_UNEXPECTED_ERROR_MESSAGE =
  "Failed to verify two-factor authentication code";
export const UPGRADE_2FA_UNEXPECTED_ERROR_MESSAGE =
  "Failed to upgrade two-factor authentication.";
export const ACTIVATE_GLOBAL_USER_UNEXPECTED_ERROR_MESSAGE = "Failed to activate user";
export const LINK_USERS_UNEXPECTED_ERROR_MESSAGE = "Failed to link users";
export const CONFIRM_NEW_EMAIL_UNEXPECTED_ERROR_MESSAGE = "Failed to update email address";
export const SET_LOGIN_COOKIES_UNEXPECTED_ERROR_MESSAGE = "Failed to login";
export const UPDATE_GLOBAL_USER_UNEXPECTED_ERROR_MESSAGE = "Failed to update user";
export const UPDATE_2FA_UNEXPECTED_ERROR_MESSAGE = "Failed to update 2fa configuration";

export const SMS_RESEND_2FA_CODE_SUCCESS_MESSAGE =
  "New code sent. If you do not receive it, please confirm that your mobile phone number is correct.";

export const EMAIL_RESEND_2FA_CODE_SUCCESS_MESSAGE =
  "New code sent. If you do not receive it, please try again.";
export const SSO_CONFIG_ERROR_MESSAGE = "Failed to update the SSO config";
export const SSO_STATUS_CONFIG_ERROR_MESSAGE = "Failed to update the SSO status config";

export const HELPER_TOOLTIP_2FA_MESSAGE = `If you don’t recognize this number, first consider others in your organization who use the same email to access other investor portals. This portal was recently upgraded and linked with other portals that share an email address. If you have any questions contact us at ${JSQ_SUPPORT_EMAIL}`;
